export default "__VITE_ASSET__CbfIv0yG__"